import { ListaSolicitacoes } from '@/components/PagesComponents/ListaSolicitacoes';


const ListarSolicitacoesGraduacao = () => {
    return(
        <>
            <h1>Graduação - Solicitações</h1>

            <ListaSolicitacoes />
        </>
    );
}

export { ListarSolicitacoesGraduacao };